module.exports = __webpack_public_path__ + "img/3lz.2a3406ea.png";